<div class="premium-error-container">
  <div class="error-icon-wrapper">
    <i
      nz-icon
      nzType="close-circle"
      nzTheme="fill"
      class="error-icon"
    ></i>
  </div>

  <h2 class="error-title">{{ title }}</h2>

  <div class="error-message-box">
    <p>{{ message }}</p>
  </div>

  <div class="action-footer">
    <button
      nz-button
      nzType="primary"
      nzDanger
      nzShape="round"
      class="submit-btn"
      type="button"
      (click)="close()"
    >
      Acknowledge
    </button>
  </div>
</div>
